import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  public readonly dialogContentId: string;

  @Input() title: string;
  @Input() subtitle: string;
  @Input() displayActionContainerAsColumnOnMobile: boolean;

  @Input() isLoading: boolean;

  @Input() hideCloseButtonIcon: boolean;
  @Input() hideButtonContainer: boolean;

  @Input() set scrollToTopTrigger(_value: boolean) {
    this.scrollToTop();
  }

  @Output() closeButtonClick = new EventEmitter<void>();
  @Output() scrolledToTheEnd = new EventEmitter<void>();

  constructor() {
    this.dialogContentId = `dialog-content-${new Date().getTime()}`;
  }

  public closeDialog(): void {
    if (this.isLoading) {
      return;
    }
    this.closeButtonClick.emit();
  }

  private scrollToTop(): void {
    const container = document.getElementById(this.dialogContentId);

    if (container) {
      container.scrollTop = 0;
    }
  }
}
